
import { Mixins, Component, Watch } from 'vue-property-decorator';
import BsMixin from '@/views/Home/mixins/bsMixin';
import api from '@/api/verify';
import noData from '@/components/noData/index.vue';
import { tSearch } from '@/components/Search/index';
import cardList from './components/cardList.vue';
import SearchForm from './components/searchForm.vue';
import pageMixin from '../../../mixins/pageMixin';

@Component({
  components: {
    cardList,
    tSearch,
    SearchForm,
    noData,
  },
})
export default class works extends Mixins(BsMixin, pageMixin) {
  private searchValue: string = '';

  private searchFormValue: string = '';

  private worksData: any = [];

  private status: any = [2];

  private casValue: any = [2];

  private activeStatus: any = [2];

  private loading = true;

  private noDataFlag: boolean = false;

  private saveStatus: any = '';

  private search: any = {
    title: '',
    orgPid: '',
    status: [2],
  }

  private searchList: any = {
    title: '',
    orgPid: '',
    status: [],
  }

  private searchData: any = [{
    value: 4,
    label: '全部',
  },
  {
    value: 2,
    label: '未审核',
  },
  {
    value: '已审核',
    label: '已审核',
    children: [{
      value: 1,
      label: '审核已通过',
    }, {
      value: 3,
      label: '审核未通过',
    }],
  }]

  public $refs!: {
    searchForm: SearchForm;
  }

  mounted() {
    this.page.pageSize = 42;
    this.getData(this.search);
  }

  handleSearchChange(v: any) {
    if (v !== '') {
      this.activeStatus = v;
      const status = this.getSearchNumber(v);
      this.search.status = status;
      this.getData(this.search, true);
    }
  }

  handleActivateChange(active: boolean) {
    if (active) {
      this.saveStatus = this.casValue;
      this.casValue = '';
    } else {
      this.casValue = this.saveStatus;
    }
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索提交事件
   */
  handleAdvancedSearch() {
    const form: any = this.$refs.searchForm.getFormData();
    const status = this.getSearchNumber(form.status);
    const searchForm = { ...form };
    searchForm.status = status;
    if ((form.status !== '' && form.status) !== null || form.title !== '' || form.orgPid !== '') {
      this.loading = true;
      this.getData(searchForm, true);
    }
    this.saveStatus = form.status;
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索清空按钮事件
   */
  handleAdvanceClear() {
    this.$refs.searchForm.handleClear();
    this.search.title = '';
    this.search.orgPid = '';
    this.search.status = [2];
    this.saveStatus = [2];
    this.getData(this.search, true);
  }

  getData(params: any, refresh: boolean = false) {
    const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo, ...this.page.params };
    api.getWorks(data, params.status, params.title, params.orgPid).then((res: any) => {
      if (refresh) {
        this.worksData = [];
        this.page.pageNo = 1;
        this.page.total = 0;
      }
      this.worksData.push(...res.content);
      this.page.total = res.totalElements;
      this.loading = false;
      if (this.worksData.length === 0) {
        this.noDataFlag = true;
      } else {
        this.noDataFlag = false;
      }
    });
  }

  /**
   * @author niuhong
   * @desc 根据搜索下拉列表获取搜索值
   */
  /* eslint-disable class-methods-use-this */
  getSearchNumber(searchStatus: any) {
    let status: any = null;
    if (searchStatus[0] === 4) {
      status = [1, 2, 3];
    } else if (searchStatus.length > 1) {
      const formStatus = searchStatus[1];
      status = formStatus;
    } else {
      status = [2];
    }
    return status;
  }

  // 点击审核确定按钮后重新获取值
  eventGetData() {
    this.getData(this.search, true);
  }

  getScrollData() {
    if (this.worksData.length === (this.page.total || 0)) return;
    if (this.searchList.orgPid === '' && this.searchList.title === '' && this.searchList.status.length === 0) {
      this.page.pageNo += 1;
      this.getData(this.search);
    } else {
      this.page.pageNo += 1;
      this.getData(this.searchList);
    }
  }
}
